module.exports = __webpack_public_path__ + "static/media/logo.b97096bb.png";